import { render } from "./Cover.vue?vue&type=template&id=ddbdeb0e&scoped=true&ts=true"
import script from "./Cover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cover.vue?vue&type=script&setup=true&lang=ts"

import "./Cover.vue?vue&type=style&index=0&id=ddbdeb0e&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbdeb0e"],['__file',"src/components/player/Cover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddbdeb0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddbdeb0e', __exports__)) {
    console.log('reload')
    api.reload('ddbdeb0e', __exports__)
  }
  
  module.hot.accept("./Cover.vue?vue&type=template&id=ddbdeb0e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('ddbdeb0e', render)
  })

}


export default __exports__